import type { FormDetail, FormSharingDto, SubmissionDetail, TemplateDetail } from '../types';
import { mockForms, mockSubmissions } from './forms.mock';
import { mockTemplates } from './templates.mock';

/**
 * Shared mutable mock state for the forms feature, extracted to its own leaf
 * module so `forms.service.ts` and `templates.service.ts` can both read/write
 * it (e.g. `instantiate` creates a Form, `saveAsTemplate` creates a Template)
 * without a circular import between the two service files.
 */

/** Mock stand-in for the authenticated user, used only to seed `getAssignedToMe`. */
export const MOCK_CURRENT_USER_ID = 'current-user';

export const formsMockState: FormDetail[] = [...mockForms];
export const submissionsMockState: SubmissionDetail[] = [...mockSubmissions];
export const templatesMockState: TemplateDetail[] = [...mockTemplates];

export function defaultSharingFor(form: FormDetail): FormSharingDto {
  return {
    audienceType: form.audienceType,
    recipients: [],
    expiresAt: form.expiresAt,
    publicLink: null,
  };
}

export const formsSharingMockState: Record<string, FormSharingDto> = Object.fromEntries(
  formsMockState.map((f) => [f.id, defaultSharingFor(f)]),
);

// Seed one form as `Specific` so `getAssignedToMe` has data to return.
if (formsSharingMockState['9002']) {
  formsSharingMockState['9002'] = {
    audienceType: 'Specific',
    recipients: [
      {
        userId: MOCK_CURRENT_USER_ID,
        email: null,
        type: 'Member',
        token: 'mock-token-9002-0',
        tokenSentAt: '2026-07-01T09:00:00Z',
        respondedAt: null,
        displayName: 'Usuario actual',
        avatarUrl: null,
      },
      {
        userId: null,
        email: 'externo@cliente.com',
        type: 'Email',
        token: 'mock-token-9002-1',
        tokenSentAt: '2026-07-01T09:00:00Z',
        respondedAt: '2026-07-02T11:00:00Z',
        displayName: null,
        avatarUrl: null,
      },
    ],
    expiresAt: null,
    publicLink: null,
  };
}
